<script lang="ts">
  import Button from './Button.svelte';

  interface Props {
    label: string;
    actionLabel: string;
    onAction: () => void;
  }

  let { label, actionLabel, onAction }: Props = $props();
</script>

<div class="toast" role="status">
  <span>{label}</span>
  <Button size="sm" variant="primary" onclick={onAction}>{actionLabel}</Button>
</div>

<style>
  .toast {
    position: fixed;
    bottom: var(--space-5);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: var(--space-4);
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-md);
    background: var(--bg-elevated);
    border: 1px solid var(--border-strong);
    box-shadow: var(--shadow-lg);
    z-index: 102;
  }
</style>
